import Specialty from './Specialty'
import { Model } from '@vuex-orm/core'

export class Oncology extends Specialty {
  static entity = 'oncology'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields()
    }
  }
}

export class ICDOCode extends Model {
  static entity = 'icdocode'

  static fields() {
    return {
      site_recode: this.string(),
      site_description: this.string(),
      histology: this.string(),
      histology_description: this.string(),
      histology_behavior: this.string(),
      histology_behavior_description: this.string()
    }
  }
}
